import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { LOGO_URL_WHITE, CONTACT, ONE_WORLD, NEOPOLIS, OTHER_PROJECT_NOTE } from "../content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ink border-t border-[#F9F8F6]/10 pt-16 md:pt-20 pb-28 md:pb-10">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 pb-12 border-b border-[#F9F8F6]/10">
          <div className="md:col-span-5">
            <img src={LOGO_URL_WHITE} alt="Seventh Cross Advisory" className="h-12 md:h-14 w-auto object-contain" />
            <p className="mt-6 text-sm font-normal text-[#F9F8F6]/70 leading-relaxed max-w-sm">
              Marketed by <span className="text-gold">Seventh Cross Advisory</span> — independent real
              estate advisors and authorised channel partner for Sobha Limited, Bengaluru.
            </p>
            <p className="mt-4 text-sm font-normal text-[#F9F8F6]/70 leading-relaxed max-w-sm">
              Real estate decisions made clearer. Zero advisory fee, zero brokerage.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="text-[11px] uppercase tracking-editorial text-gold mb-6">Projects</p>
            <div className="flex flex-col gap-4">
              <Link data-testid="footer-link-one-world" to={`/${ONE_WORLD.slug}`} className="text-sm font-normal text-[#F9F8F6]/70 hover:text-gold transition-colors w-fit">
                Sobha One World · Hoskote
              </Link>
              <Link data-testid="footer-link-neopolis" to={`/${NEOPOLIS.slug}`} className="text-sm font-normal text-[#F9F8F6]/70 hover:text-gold transition-colors w-fit">
                Sobha Neopolis · Panathur
              </Link>
            </div>
            <p className="text-[11px] uppercase tracking-editorial text-gold mt-10 mb-4">RERA</p>
            <p className="text-[11px] font-normal text-[#F9F8F6]/50 leading-relaxed max-w-[240px]">
              Sobha One World Phase 1: PRM/KA/RERA/1250/304/PR/080526/008634 (Phases 008634–008639).
              Sobha Neopolis: RERA registered.
            </p>
          </div>
          <div className="md:col-span-4">
            <p className="text-[11px] uppercase tracking-editorial text-gold mb-6">Contact</p>
            <div className="flex flex-col gap-4">
              <a data-testid="footer-phone-link" href={CONTACT.phoneHref} className="flex items-center gap-3 text-sm font-normal text-[#F9F8F6]/70 hover:text-gold transition-colors">
                <Phone size={14} strokeWidth={1.5} /> {CONTACT.phone}
              </a>
              <a data-testid="footer-email-link" href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-sm font-normal text-[#F9F8F6]/70 hover:text-gold transition-colors">
                <Mail size={14} strokeWidth={1.5} /> {CONTACT.email}
              </a>
              <a data-testid="footer-whatsapp-link" href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm font-normal text-[#F9F8F6]/70 hover:text-gold transition-colors">
                <MessageCircle size={14} strokeWidth={1.5} /> WhatsApp us
              </a>
              <a data-testid="footer-address-link" href={CONTACT.maps} target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 text-sm font-normal text-[#F9F8F6]/70 hover:text-gold transition-colors">
                <MapPin size={14} strokeWidth={1.5} className="mt-1 shrink-0" />
                <span className="leading-relaxed">{CONTACT.address}</span>
              </a>
            </div>
          </div>
        </div>
        <div className="pt-8 flex flex-col md:flex-row justify-between gap-4">
          <p className="text-[11px] font-normal text-[#F9F8F6]/50">
            © {new Date().getFullYear()} Seventh Cross Advisory. All rights reserved.
          </p>
          <p className="text-[11px] font-normal text-[#F9F8F6]/50 max-w-xl md:text-right">
            This is a channel-partner marketing page, not the official Sobha Limited website. {OTHER_PROJECT_NOTE} *T&C apply.
          </p>
        </div>
      </div>
    </footer>
  );
}
